/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  CostumeInventoryReportService,
  ICostumeInventoryReportMethods,
  SectionOptInventoryReportService,
  ISectionOptInventoryReportMethods,
  IPaymentReportMethods,
  PaymentReportService,
  IMasqReportMethods,
  MasqReportService,
  IGetZeroPaymentReportMethods,
  GetZeroPaymentReportService,
  IGetFullPaymentReportMethods,
  GetFullPaymentReportService,
  IInactiveBoxesReportMethods,
  InactiveBoxesReportService,
  IGetFeatureReportMethods,
  GetFeatureReportService,
  IGetPartialPaymentReportMethods,
  GetPartialPaymentReportService,
  IopenRegReportMethods,
  OpenRegReportService,
  IGetCommitteeReportMethods,
  GetCommitteeReportService,
  IGetDiscountedReportMethods,
  GetDiscountedReportService,
  IGetSchedulesReportMethods,
  GetSchedulesReportService,
  DeliveredReportService,
  IDeliveredReportMethods,
  CouponReportService,
  ICouponReportMethods,
  IDiscountCouponReportMethods,
  DiscountCouponReportService,
  IInactiveUpdatedBoxesReportMethods,
  InactiveUpdatedBoxesReportService,
  IPrintSummaryReportMethods,
  PrintSummaryReportService,
} from "./components";

export type PurchasedCostumePageAgent = IStaticPageContentMethods &
  IPaymentReportMethods &
  ISectionOptInventoryReportMethods &
  IMasqReportMethods &
  IGetZeroPaymentReportMethods &
  IGetFullPaymentReportMethods &
  IPrintSummaryReportMethods &
  IGetPartialPaymentReportMethods &
  IGetDiscountedReportMethods &
  IInactiveBoxesReportMethods &
  IGetFeatureReportMethods &
  IopenRegReportMethods &
  IGetCommitteeReportMethods &
  IGetSchedulesReportMethods &
  IInactiveUpdatedBoxesReportMethods &
  ICostumeInventoryReportMethods &
  IDeliveredReportMethods &
  IDiscountCouponReportMethods &
  ICouponReportMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new PrintSummaryReportService(),
    new SectionOptInventoryReportService(),
    new PaymentReportService(),
    new CostumeInventoryReportService(),
    new MasqReportService(),
    new GetDiscountedReportService(),
    new GetZeroPaymentReportService(),
    new InactiveBoxesReportService(),
    new InactiveUpdatedBoxesReportService(),
    new GetFullPaymentReportService(),
    new GetPartialPaymentReportService(),
    new OpenRegReportService(),
    new GetFeatureReportService(),
    new DiscountCouponReportService(),
    new GetCommitteeReportService(),
    new GetSchedulesReportService(),
    new DeliveredReportService(),
    new CouponReportService(),
  ];
};

export const getAgent = () => {
  return createAgent<PurchasedCostumePageAgent>({
    plugins: getPlugins(),
  });
};
